"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _jdMarketing = require("@/api/operationManagement/jdMarketing");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultFormData = function defaultFormData() {
  return {
    accountId: '',
    // 京东联盟 ID（联盟id）
    unionId: '',
    // 应用 ID
    appKey: '',
    // 京东联盟 appKey
    appSecret: '',
    // 京东联盟 appSecret
    remark: '' // 备注（后端暂不支持保存）
  };
};
var _default = exports.default = {
  name: 'OverSupplementing',
  data: function data() {
    return {
      tableData: [],
      dialogVisible: false,
      dialogType: 'add',
      // add-添加联盟信息 edit-编辑联盟信息
      saveLoading: false,
      tipVisible: false,
      formData: defaultFormData(),
      formRules: {
        accountId: [{
          required: true,
          message: '请输入京东联盟 ID',
          trigger: 'blur'
        }],
        unionId: [{
          required: true,
          message: '请输入应用 ID',
          trigger: 'blur'
        }],
        appKey: [{
          required: true,
          message: '请输入应用 App Key',
          trigger: 'blur'
        }],
        appSecret: [{
          required: true,
          message: '请输入应用 App Secret',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    // 平台应用 ID（接口必填）
    appId: function appId() {
      return this.$store.getters.appId;
    },
    userId: function userId() {
      return this.$store.getters.userId;
    }
  },
  created: function created() {
    this.getList();
  },
  methods: {
    // 查询联盟配置列表
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _jdMarketing.get_jd_activity)({
                appId: this.appId,
                userId: this.userId
              });
            case 1:
              res = _context.v;
              this.tableData = res.data || [];
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    // 添加
    onAdd: function onAdd() {
      this.dialogType = 'add';
      this.formData = defaultFormData();
      this.dialogVisible = true;
    },
    // 编辑
    onEdit: function onEdit(row) {
      this.dialogType = 'edit';
      this.formData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, defaultFormData()), row);
      this.dialogVisible = true;
    },
    // 保存（新增/编辑共用同一接口）
    onSave: function onSave() {
      var _this = this;
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(valid) {
          var _t2;
          return (0, _regenerator2.default)().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                if (valid) {
                  _context2.n = 1;
                  break;
                }
                return _context2.a(2);
              case 1:
                _this.saveLoading = true;
                _context2.p = 2;
                _context2.n = 3;
                return (0, _jdMarketing.save_jd_activity)({
                  userId: Number(_this.userId) || 0,
                  appId: Number(_this.appId) || 0,
                  accountId: _this.formData.accountId,
                  unionId: _this.formData.unionId,
                  appKey: _this.formData.appKey,
                  appSecret: _this.formData.appSecret
                });
              case 3:
                _this.$message.success(_this.dialogType === 'add' ? '添加成功' : '保存成功');
                _this.dialogVisible = false;
                _this.getList();
                _context2.n = 5;
                break;
              case 4:
                _context2.p = 4;
                _t2 = _context2.v;
                // 联盟应用被占用等冲突，弹出提示框
                _this.tipVisible = true;
              case 5:
                _context2.p = 5;
                _this.saveLoading = false;
                return _context2.f(5);
              case 6:
                return _context2.a(2);
            }
          }, _callee2, null, [[2, 4, 5, 6]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 删除（二次确认）
    onDelete: function onDelete(row) {
      var _this2 = this;
      this.$confirm('删除后不可恢复，是否删除该联盟信息？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return (0, _jdMarketing.del_jd_activity)({
                userId: Number(_this2.userId) || 0,
                appId: Number(_this2.appId) || 0,
                appKey: row.appKey
              });
            case 1:
              _this2.$message.success('删除成功');
              _this2.getList();
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }))).catch(function () {});
    },
    onDialogClosed: function onDialogClosed() {
      this.$refs.formRef && this.$refs.formRef.clearValidate();
    }
  }
};